import getAPIResponse from "Shared/Utils/Domain/Services/GetAPIResponsePrivateService";
import { ServiceContactDelegation } from "../../Model/ServiceContactDelegation/ServiceContactDelegation";

export async function getServiceContactDelegation(id) {
    let response = await getAPIResponse("/v1/service-contact-delegation/" + id);
    if (response === null) {
        return null;
    }
    return ServiceContactDelegation.createFromResponseData(response);
}
